import { render, staticRenderFns } from "./ConfirmDlg.vue?vue&type=template&id=096bb672&"
import script from "./ConfirmDlg.vue?vue&type=script&lang=js&"
export * from "./ConfirmDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports